





import {Component, Vue} from 'vue-property-decorator';
import anime from "animejs"

@Component
export default class JdsCandidateBubbleColumnLayout extends Vue {

    enter(el: HTMLElement, done: ()=>void) {
        let i = Array.prototype.indexOf.call(el.parentNode?.children, el);
        // let subItems = el.querySelectorAll('.jdsa-cell');

        anime.timeline({
            easing: 'easeOutBack',
            complete: done,
        }).add({
            targets: el,
            translateX: [-50, 0],
            scaleY: [0.2, 1],
            opacity: [0, 1],
            duration: 150,
            delay: i * 25,
        })
        // .add({
        //     targets: subItems,
        //     easing: 'easeOutExpo',
        //     translateY: [-20, 0],
        //     opacity: [0, 1],
        //     duration: 100,
        //     delay: anime.stagger(40),
        // }, 150 + (i * 40));
    }

    leave(el: Node, done: ()=>void) {
        done();
    }
}
